import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { OrdemServicoStore } from '../../data-access/ordem-servico.store';
import { StatusOS } from '../../models';

@Component({
  selector: 'app-os-quickpanel-widget',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
  templateUrl: './os-quickpanel-widget.html',
})
export class OsQuickpanelWidget implements OnInit {
  private readonly router = inject(Router);
  readonly store = inject(OrdemServicoStore);

  ngOnInit(): void {
    if (!this.store.temOsAtiva() && !this.store.isLoading()) {
      this.store.carregarOsDoTurno();
    }
  }

  navegar(id: string): void {
    this.router.navigate(['/ordem-servico', id]);
  }

  statusLabel(status: string): string {
    switch (status) {
      case StatusOS.APROVADA: return 'Aprovada';
      case StatusOS.EM_EXECUCAO: return 'Em Execução';
      case StatusOS.CONCLUIDA: return 'Concluída';
      case StatusOS.CANCELADA: return 'Cancelada';
      default: return 'Planejamento';
    }
  }

  statusClasses(status: string): string {
    switch (status) {
      case StatusOS.APROVADA: return 'bg-pmdf-success-soft text-pmdf-success';
      case StatusOS.EM_EXECUCAO: return 'bg-pmdf-warning-soft text-pmdf-muted-70';
      case StatusOS.CONCLUIDA: return 'bg-pmdf-bg-muted text-pmdf-muted-55';
      case StatusOS.CANCELADA: return 'bg-pmdf-danger-soft text-pmdf-danger';
      default: return 'bg-pmdf-info-soft text-pmdf-info';
    }
  }

  formatarHorario(iso: string): string {
    return new Date(iso).toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
    });
  }
}
